import { setScrollTrigger } from "./parts/settings/gsap/scrolltrigger";
import { params } from "./parts/vars/params";
import { elms } from "./parts/vars/elms";
import { resize } from "./parts/utils/resize";
import { setResize } from "./parts/utils/set-resize";
import { scroll } from "./parts/utils/scroll";
import { updateSvgScale } from "./parts/utils/svg-scale";
import { ham } from "./parts/components/common/ham";
import { header } from "./parts/components/common/header";
import { marquee } from "./parts/components/common/marquee";
import { storyMarquee } from "./parts/components/top/story-marquee";
import { para } from "./parts/components/common/para";
import { scrollIn } from "./parts/components/common/scrollIn";
import { tabs } from "./parts/components/common/tabs";
import { accordion } from "./parts/components/common/accordion";
import { followToc } from "./parts/components/common/article-grid";
import { copyright } from "./parts/components/common/copyright";
import { scrollTo } from "./parts/components/common/scrollTo";
import { slider } from "./parts/components/common/slider";
import { topMv } from "./parts/components/top/mv";
import { autoAddress } from "./parts/settings/autoAddress";
import { btnFixed } from "./parts/components/common/btn";
// import {twoDigits, addComma, inArray} from './lib/utils';
// {twoDigits, addComma, inArray}

const userAgent = navigator.userAgent.toLowerCase();
const isMobile = /iphone|ipod|ipad|android/.test(userAgent);
const bodyClass = isMobile ? "mobile" : "pc";
document.body.classList.add(bodyClass);

const disableTelLinksOnPc = (): void => {
  if (isMobile) return;
  const telLinks = document.querySelectorAll<HTMLAnchorElement>('a[href^="tel:"]');
  telLinks.forEach((link) => {
    link.addEventListener("click", (e) => {
      e.preventDefault();
    });
  });
};

let initialized: boolean = false;

setTimeout(() => {
  init();
}, 3000);

window.addEventListener("load", () => {
  init();
  params.loadingComplete = true;
});

const init = (): void => {
  if (initialized) {
    return;
  }

  initialized = true;

  disableTelLinksOnPc();

  if (elms.ham) ham();
  if (elms.header) header();
  scrollTo();
  topMv();
  marquee();
  storyMarquee();
  para();
  scrollIn();
  tabs();
  accordion();
  followToc();
  copyright();
  slider();
  setScrollTrigger();
  resize();
  // Initial SVG scaling
  updateSvgScale();
  setResize();
  scroll();
  autoAddress();
  btnFixed();
  document.querySelector("body")?.classList.add("is-initialized");
  console.log("init");
};
